// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom"; // ✅ import navigation
// import AdminAppBody from "../../../../components/admin/AdminAppBody";
// import useApiCallHooks from "../../../../hooks/useApiCallHooks";
// import Select from "react-select";
// import { toast } from "react-toastify";

// const NewSession = () => {
//   const navigate = useNavigate(); // ✅ initialize navigate

//   const [programs, setPrograms] = useState([]);
//   const [students, setStudents] = useState([]);
//   const [modules, setModules] = useState([]);
//   const [topics, setTopics] = useState([]);
//   const [groups, setGroups] = useState([]);

//   const [responce, loading, error, callAPI,statusCode] = useApiCallHooks();

//   const [form, setForm] = useState({
//     title: "",
//     program_id: "",
//     user_type: "",
//     module_id: "",
//     topic_id: "",
//     start_date: "",
//     time: "",
//     type: "individual", // ✅ change from array to default string
//     student_ids: [],
//     group_id: [], // ✅ group_id not group_ids
//     url: "",
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = () => {
//     const sessionData = { ...form };
//     console.log("Submitted Data:", sessionData);
//     callAPI("post", "mentor/create-session", sessionData);
//   };

//   // Get students list
//   useEffect(() => {
//     if (form.user_type) {
//       callAPI("get", `get-program-student-list/${form.user_type}`, "");
//     }
//   }, [form.user_type]);

//   // Get modules when program changes
//   useEffect(() => {
//     if (form.program_id) {
//       callAPI("get", `road-map/${form.program_id}`, "");
//     }
//   }, [form.program_id]);

//   // Get topics when module changes
//   useEffect(() => {
//     if (form.module_id) {
//       callAPI("get", `module-wise-topic/${form.module_id}`, "");
//     }
//   }, [form.module_id]);

//   // Load groups on mount
//   useEffect(() => {
//     callAPI("get", `mentor/mentor-group-student-list`, "");
//   }, []);

//   // Handle API responses
//   useEffect(() => {
//     if (!responce?.data) return;

//     const data = responce.data;

//     console.log("API Message:", responce.message);
//     console.log("API Data:", data);

//     if (Array.isArray(data.programs)) setPrograms(data.programs);
//     if (Array.isArray(data.students)) setStudents(data.students);
//     if (responce.message === "RoadMapModules" && Array.isArray(data)) setModules(data);
//     if (Array.isArray(data) && data[0]?.module_id) setTopics(data);
//     if (data.groups && Array.isArray(data.groups)) setGroups(data.groups);

//     // ✅ Navigate to session list after successful session creation
//      if (statusCode === 201) {
//     toast.success('Session created successfully!');
//     setTimeout(() => {
//       navigate('/mentor/session/list');
//     }, 1000); // Delay to let user see the toast
//   }
//   }, [responce]);

//   return (
//     <AdminAppBody
//     loading={loading}
//       content={
//         <div className="container mt-3">
//           <h3>Create New Session</h3>
//           <div className="card shadow">
//             <div className="card-body">
//               {/* Title */}
//               <div className="mb-3">
//                 <label>Session Title</label>
//                 <input
//                   type="text"
//                   name="title"
//                   className="form-control"
//                   placeholder="Enter session title"
//                   value={form.title}
//                   onChange={handleChange}
//                 />
//               </div>

//               {/* Program & User Type */}
//               <div className="row mb-3">
//                 <div className="col-md-6">
//                   <label>Student Type</label>
//                   <select
//                     className="form-control"
//                     name="user_type"
//                     value={form.user_type}
//                     onChange={handleChange}
//                     required
//                   >
//                     <option value="">-- Select Student Type --</option>
//                     <option value="kids">Kids</option>
//                     <option value="student">Student</option>
//                   </select>
//                 </div>
//                 <div className="col-md-6">
//                   <label>Select Program</label>
//                   <select
//                     className="form-select"
//                     name="program_id"
//                     value={form.program_id}
//                     onChange={handleChange}
//                   >
//                     <option value="">Select</option>
//                     {programs.map((prog) => (
//                       <option key={prog.id} value={prog.id}>
//                         {prog.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>

//               {/* Module & Topic */}
//               <div className="row mb-3">
//                 <div className="col-md-6">
//                   <label>Select Module</label>
//                   <select
//                     className="form-select"
//                     name="module_id"
//                     value={form.module_id}
//                     onChange={handleChange}
//                     disabled={!modules.length}
//                   >
//                     <option value="">-- Select Module --</option>
//                     {modules.map((mod) => (
//                       <option key={mod.id} value={mod.id}>
//                         {mod.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 <div className="col-md-6">
//                   <label>Select Topic</label>
//                   <select
//                     className="form-select"
//                     name="topic_id"
//                     value={form.topic_id}
//                     onChange={handleChange}
//                     disabled={!topics.length}
//                   >
//                     <option value="">-- Select Topic --</option>
//                     {topics.map((topic) => (
//                       <option key={topic.id} value={topic.id}>
//                         {topic.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>

//               {/* Date & Time */}
//               <div className="row mb-3">
//                 <div className="col-md-6">
//                   <label>Session Date</label>
//                   <input
//                     type="date"
//                     name="start_date"
//                     className="form-control"
//                     value={form.start_date}
//                     onChange={handleChange}
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label>Session Time</label>
//                   <input
//                     type="time"
//                     name="time"
//                     className="form-control"
//                     value={form.time}
//                     onChange={handleChange}
//                   />
//                 </div>
//               </div>

//               {/* Session Type */}
//               <div className="mb-3">
//                 <label>Session Type:</label>
//                 {["individual", "group"].map((type) => (
//                   <div className="form-check form-check-inline ms-2" key={type}>
//                     <input
//                       type="radio"
//                       className="form-check-input"
//                       name="type"
//                       value={type}
//                       checked={form.type === type}
//                       onChange={(e) => {
//                         setForm((prev) => ({
//                           ...prev,
//                           type: e.target.value,
//                           student_ids: [],
//                           group_id: "",
//                         }));
//                       }}
//                     />
//                     <label className="form-check-label text-capitalize">{type}</label>
//                   </div>
//                 ))}
//               </div>

           
// {form.type === "individual" && (
//   <div className="mb-3">
//     <label>Select Students</label>
//     <Select
//       isMulti
//       name="student_ids"
//       options={students.map((item) => ({
//         value: item.student.id,
//         label: `${item.student.first_name} ${item.student.last_name || ""}`.trim(),
//       }))}
//       value={students
//         .filter((s) => form.student_ids.includes(s.student.id))
//         .map((s) => ({
//           value: s.student.id,
//           label: `${s.student.first_name} ${s.student.last_name || ""}`.trim(),
//         }))}
//       onChange={(selectedOptions) =>
//         setForm((prev) => ({
//           ...prev,
//           student_ids: selectedOptions.map((option) => option.value),
//         }))
//       }
//     />
//   </div>
// )}




//               {form.type === "group" && (
//                 <div className="mb-3">
//                   <label>Select Group</label>
//                   <Select
//                     name="group_id"
//                     options={groups.map((group) => ({
//                       value: group.id,
//                       label: group.name,
//                     }))}
//                     value={
//                       groups
//                         .filter((g) => g.id === form.group_id)
//                         .map((g) => ({ value: g.id, label: g.name }))[0] || null
//                     }
//                     onChange={(selectedOption) =>
//                       setForm((prev) => ({
//                         ...prev,
//                         group_id: selectedOption?.value || "",
//                       }))
//                     }
//                   />
//                 </div>
//               )}

//               {/* URL */}
//               <div className="mb-3">
//                 <label>Session Link</label>
//                 <input
//                   type="url"
//                   name="url"
//                   className="form-control"
//                   placeholder="Enter session URL (Zoom/Meet)"
//                   value={form.url}
//                   onChange={handleChange}
//                 />
//               </div>

//               {/* Submit */}
//               <div className="text-end">
//                 <button className="btn btn-primary" onClick={handleSubmit} >
//                   Submit
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       }
//     />
//   );
// };

// export default NewSession;


import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import Select from "react-select";
import { toast } from "react-toastify";

const NewSession = () => {
  const navigate = useNavigate();

  const [programs, setPrograms] = useState([]);
  const [students, setStudents] = useState([]);
  const [modules, setModules] = useState([]);
  const [topics, setTopics] = useState([]);
  const [groups, setGroups] = useState([]);

  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();

  const [form, setForm] = useState({
    title: "",
    program_id: "",
    user_type: "",
    module_id: "",
    topic_id: "",
    start_date: "",
    time: "",
    type: "individual", 
    student_ids: [],
    group_id: "", 
    url: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    const sessionData = { ...form };
    console.log("Submitted Data:", sessionData);
    callAPI("post", "mentor/create-session", sessionData);
  };

  // Get students list
  useEffect(() => {
    if (form.user_type) {
      callAPI("get", `get-program-student-list/${form.user_type}`, "");
    }
  }, [form.user_type]);

  // Get modules when program changes
  useEffect(() => {
    if (form.program_id) {
      callAPI("get", `road-map/${form.program_id}`, "");
    }
  }, [form.program_id]);

  // Get topics when module changes
  useEffect(() => {
    if (form.module_id) {
      callAPI("get", `module-wise-topic/${form.module_id}`, "");
    }
  }, [form.module_id]);

  // Load groups on mount
  useEffect(() => {
    callAPI("get", `mentor/mentor-group-student-list`, "");
  }, []);

  // Handle API responses
  useEffect(() => {
    if (!responce?.data) return;

    const data = responce.data;

    console.log("API Message:", responce.message);
    console.log("API Data:", data);

    if (Array.isArray(data.programs)) setPrograms(data.programs);
    if (Array.isArray(data.students)) setStudents(data.students);
    if (responce.message === "RoadMapModules" && Array.isArray(data)) setModules(data);
    if (Array.isArray(data) && data[0]?.module_id) setTopics(data);
    if (data.groups && Array.isArray(data.groups)) setGroups(data.groups);

    if (statusCode === 201) {
      toast.success("Session created successfully!");
      setTimeout(() => {
        navigate("/mentor/session/list");
      }, 1000);
    }
  }, [responce, statusCode, navigate]);

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container mt-3">
          <h3>Create New Session</h3>
          <div className="card shadow">
            <div className="card-body">
              {/* Title */}
              <div className="mb-3">
                <label>Session Title</label>
                <input
                  type="text"
                  name="title"
                  className="form-control"
                  placeholder="Enter session title"
                  value={form.title}
                  onChange={handleChange}
                />
              </div>

              {/* Program & User Type */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label>Student Type</label>
                  <select
                    className="form-control"
                    name="user_type"
                    value={form.user_type}
                    onChange={handleChange}
                    required
                  >
                    <option value="">-- Select Student Type --</option>
                    <option value="kids">Kids</option>
                    <option value="student">Student</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label>Select Program</label>
                  <select
                    className="form-select"
                    name="program_id"
                    value={form.program_id}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    {programs.map((prog) => (
                      <option key={prog.id} value={prog.id}>
                        {prog.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Module & Topic */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label>Select Module</label>
                  <select
                    className="form-select"
                    name="module_id"
                    value={form.module_id}
                    onChange={handleChange}
                    disabled={!modules.length}
                  >
                    <option value="">-- Select Module --</option>
                    {modules.map((mod) => (
                      <option key={mod.id} value={mod.id}>
                        {mod.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6">
                  <label>Select Topic</label>
                  <select
                    className="form-select"
                    name="topic_id"
                    value={form.topic_id}
                    onChange={handleChange}
                    disabled={!topics.length}
                  >
                    <option value="">-- Select Topic --</option>
                    {topics.map((topic) => (
                      <option key={topic.id} value={topic.id}>
                        {topic.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Date & Time */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label>Session Date</label>
                  <input
                    type="date"
                    name="start_date"
                    className="form-control"
                    value={form.start_date}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6">
                  <label>Session Time</label>
                  <input
                    type="time"
                    name="time"
                    className="form-control"
                    value={form.time}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* Session Type */}
              <div className="mb-3">
                <label>Session Type:</label>
                {["individual", "group"].map((type) => (
                  <div className="form-check form-check-inline ms-2" key={type}>
                    <input
                      type="radio"
                      className="form-check-input"
                      name="type"
                      value={type}
                      checked={form.type === type}
                      onChange={(e) => {
                        setForm((prev) => ({
                          ...prev,
                          type: e.target.value,
                          student_ids: [],
                          group_id: "",
                        }));
                      }}
                    />
                    <label className="form-check-label text-capitalize">{type}</label>
                  </div>
                ))}
              </div>

              {/* Individual Student Selection */}
              {form.type === "individual" && (
                <div className="mb-3">
                  <label>Select Students</label>
                  <Select
                    isMulti
                    name="student_ids"
                    options={students
                      .filter((item) => item.student) // ✅ safe check
                      .map((item) => ({
                        value: item.student.id,
                        label: `${item.student.first_name} ${item.student.last_name || ""}`.trim(),
                      }))}
                    value={students
                      .filter((s) => s.student && form.student_ids.includes(s.student.id)) // ✅ safe check
                      .map((s) => ({
                        value: s.student.id,
                        label: `${s.student.first_name} ${s.student.last_name || ""}`.trim(),
                      }))}
                    onChange={(selectedOptions) =>
                      setForm((prev) => ({
                        ...prev,
                        student_ids: selectedOptions.map((option) => option.value),
                      }))
                    }
                  />
                </div>
              )}

              {/* Group Selection */}
              {form.type === "group" && (
                <div className="mb-3">
                  <label>Select Group</label>
                  <Select
                    name="group_id"
                    options={groups.map((group) => ({
                      value: group.id,
                      label: group.name,
                    }))}
                    value={
                      groups
                        .filter((g) => g.id === form.group_id)
                        .map((g) => ({ value: g.id, label: g.name }))[0] || null
                    }
                    onChange={(selectedOption) =>
                      setForm((prev) => ({
                        ...prev,
                        group_id: selectedOption?.value || "",
                      }))
                    }
                  />
                </div>
              )}

              {/* URL */}
              <div className="mb-3">
                <label>Session Link</label>
                <input
                  type="url"
                  name="url"
                  className="form-control"
                  placeholder="Enter session URL (Zoom/Meet)"
                  value={form.url}
                  onChange={handleChange}
                />
              </div>

              {/* Submit */}
              <div className="text-end">
                <button className="btn btn-primary" onClick={handleSubmit}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default NewSession;
